import { z } from 'zod';

export const PaginationSchema = z.object({
  page: z.number(),
  size: z.number(),
  sort: z.string(),
});

export const SortSchema = z.object({
  empty: z.boolean(),
  sorted: z.boolean(),
  unsorted: z.boolean(),
});

export const PageableSchema = z.object({
  offset: z.number(),
  paged: z.boolean(),
  pageNumber: z.number(),
  pageSize: z.number(),
  sort: SortSchema,
  unpaged: z.boolean(),
});
